import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
  name: 'sanitize'
})
export class SanitizePipe implements PipeTransform {

  constructor(private readonly sanitizer: DomSanitizer) {}

  transform(
    value: string | null | undefined,
    context: SecurityContext.HTML | SecurityContext.URL = SecurityContext.HTML
  ): string {
    if (value == null || value === '') {
      return '';
    }

    if (context !== SecurityContext.HTML && context !== SecurityContext.URL) {
      throw new Error(`Unsupported SecurityContext: ${context}. Only HTML and URL are allowed.`);
    }

    return this.sanitizer.sanitize(context, value) ?? '';
  }
}
